import script from "./ForgotAccountModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./ForgotAccountModal.vue?vue&type=script&lang=ts&setup=true"

import "./ForgotAccountModal.vue?vue&type=style&index=0&id=543a8cc0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-543a8cc0"]])

export default __exports__